import React, { useMemo } from 'react'
import styled from 'styled-components'
import Button from '../components/Button'
import FadeToggle from '../components/FadeToggle'
import { device } from '../style'
import { useTranslation } from '../store/hooks/dataHooks'
import { useCurrentConfiguration } from '../store/hooks/configurationHooks'
import { useSelector } from '../store/hooks'
import { getBOM } from '../model/ConstelaConfiguration'
import numeral from 'numeral'

const PriceLayerWrapper = styled(FadeToggle)`
  position: absolute;
  right: 40px;
  top: 40px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.2s, visibility 0.2s;
  background: #fff;
  box-shadow: 0 0 25px rgb(0 0 0 / 15%);
  z-index: 100;

  @media ${device.laptop} {
    width: auto;
    margin-top: 0;
  }

  .button {
    margin: 25px;
    min-width: 250px;
    pointer-events: all;
  }
`

const Price = styled.dl.attrs<{ $title: string }>(({ $title, children }) => ({
  children: (
    <>
      <dt>{$title}</dt>
      <dd>{children}</dd>
    </>
  )
}))<{ $title: string }>`
  margin: 20px 30px;
  font-family: DINWebPro-Bold;

  dt {
    font-size: 15px;
    opacity: 0.3;
    line-height: 1.3;
    margin-bottom: 0.4em;
    white-space: nowrap;
  }

  dd {
    font-size: 21px;
  }
`

export const PriceLayer: React.FC<{ visible?: boolean; closeOverlay?: () => unknown }> = ({
  visible,
  closeOverlay
}) => {
  const t = useTranslation()
  const configuration = useCurrentConfiguration()
  const data = useSelector((state) => state.data)
  const bom = useMemo(() => getBOM(configuration, data), [configuration, data])
  // console.log(bom)
  const showPriceInfo = useSelector((state) => state.ui.mode === 'expert' && !state.ui.expert.showApplications)
  const showPrice = useSelector((state) => state.data.language === 'de')
  const price = useMemo(() => {
    if (bom.some((x) => typeof x.portfolioItem?.price === 'undefined')) {
      return undefined
    }
    return bom.map((x) => x.portfolioItem?.price ?? 0).reduce((a, b) => a + b, 0)
  }, [bom])

  return (
    <PriceLayerWrapper visible={visible}>
      {showPriceInfo && (
        <Price $title={t('ui.systemprice.brutto')}>
          {showPrice && price ? numeral(price / 100).format('0,0.00') + ' €' : t('ui.pricerequest')}
        </Price>
      )}

      <Button onClick={closeOverlay} cta>
        {t('ui.close')}
      </Button>
    </PriceLayerWrapper>
  )
}
